import { FC } from 'react';
import { Product } from '../../../common/model';
import './FavoriteHeaderComponent.scss';
import { UserActions } from '../../../redux/UserActions';
import SortProductsComponent from '../../sortProducts/SortProductsComponent';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/AppReducer';
import { FilterActions } from '../../../redux/FilterActions';
import { ISortByOption } from '../../../common/view-model';
import { useAppDispatch } from '../../../redux/store';
import { AppActions } from '../../../redux/AppActions';
import Modal from '../../Modal/Modal';
import GroupByHallNumbers from '../GroupByHallNumbers/GroupByHallNumbers';
import { ScreenType } from '../../../common/view-model';
import LabelForms from '../../forms/GenericBaseForms/LabelForms/LabelForms';
interface IFavoriteHeaderComponentProps {
	products: Product[];
	isLoading?: boolean;
}

export const FavoriteHeaderComponent: FC<IFavoriteHeaderComponentProps> = ({
	products,
	isLoading
}) => {
	const dispatch = useAppDispatch();
	const { deviceScreen } = useSelector((state: RootState) => state.appState!);
	const downloadFavoritesCsv = () => {
		if (products.length > 0) {
			dispatch({ type: UserActions.DOWNLOAD_FAVORITE_PRODUCTS, payload: undefined });
		}
	};
	const { favoriteSortByOptions = [] } = useSelector(
		(state: RootState) => state.appState.filterState!
	);
	const onSortChange = (option: ISortByOption) => dispatch(FilterActions.setFavoriteSortBy(option));

	const setLockModalContent = () =>
		dispatch(
			AppActions.setModalContent({
				content: <Modal />,
				showCloseIcon: true,
				canScroll: false,
				closeOnDocumentClick: true
			})
		);
	const isGroupByHallDisabled = useSelector((s: RootState) => s.appState.disableGroupByHall);

	const getToolTipText = () =>
		products.length > 0 && !isGroupByHallDisabled ? (
			<>Organize your favorites into groups based on Expo West halls.</>
		) : (
			<>Grouping by Expo hall is not available for your current favorited products.</>
		);
	const showGroupByHall = import.meta.env.VITE_SHOW_ORDER_BY_HALL === 'true';
	const isMobile = deviceScreen === ScreenType.MOBILE;
	const width = window.innerWidth;
	const isLargeMobile = width === 743;

	return (
		<>
			<div
				data-testid='favorite-header-container'
				className={`favorites-container ${isMobile ? 'mobile' : ''}`}
			>
				<span className='title'>Your Favorite Products ({isLoading ? 0 : products.length}) </span>
				<button
					data-testid='export-cvs'
					className={products.length > 0 ? 'export-csv' : 'export-csv disabled'}
					onClick={downloadFavoritesCsv}
				>
					{isMobile || isLargeMobile ? 'CSV' : 'Export as CSV'}
					<i className='ri-file-line'></i>
				</button>
			</div>
			<div className='favorite-seperator'></div>
			<div className='favorite-filter-sort-container'>
				{products.length > 0 && (
					<span onClick={setLockModalContent} className='removeAllBtn'>
						<span>Remove All Favorites</span>
					</span>
				)}
				{deviceScreen != ScreenType.MOBILE && showGroupByHall && (
					<div className='group-by-hall'>
						<GroupByHallNumbers favoriteCount={products.length} />
						<LabelForms
							text=''
							icon={<i className='ri-question-line' />}
							toolTipText={getToolTipText()}
							toolTipPosition='right'
						></LabelForms>
					</div>
				)}

				<div className='favorite-filter-container'></div>
				<div className='favorite-sort-container'>
					<SortProductsComponent
						availableSorts={favoriteSortByOptions}
						isFavoritesPage={true}
						setSortBy={onSortChange}
					/>
				</div>
			</div>
			{deviceScreen === ScreenType.MOBILE && showGroupByHall && (
				<div className='group-by-hall'>
					<GroupByHallNumbers favoriteCount={products.length} />
					<LabelForms
						text=''
						icon={<i className='ri-question-line' />}
						toolTipText={getToolTipText()}
						toolTipPosition='right'
					></LabelForms>
				</div>
			)}
		</>
	);
};
